import { getAlternatePaymentMethodRequest } from '@syf-api-library/alternate-payment-methods';
import generateUUID from 'syf-js-utilities/helpers/generateUUID';
import { dchDebitCardNameAtom } from '../../../atoms/dchDebitCardAtom';
import makeAPaymentStore from '../../../store';
export const getTrackingHeaders = () => {
    return {
        'x-syf-request-trackingid': generateUUID()
    };
};
export const getAuthHeaders = () => {
    const accessToken = sessionStorage.getItem('accessToken');
    const correlationId = sessionStorage.getItem('correlationId');
    return {
        Authorization: `Bearer ${accessToken}`,
        'x-syf-request-correlationid': correlationId || ''
    };
};
export const getFormattedPayloadFromVariablesACH = (mutationVariables) => {
    const { id } = mutationVariables.paymentMethod;
    const alternatePaymentMethodRequest = getAlternatePaymentMethodRequest(id);
    if (alternatePaymentMethodRequest) {
        return alternatePaymentMethodRequest.paymentMethod;
    }
    return {
        id
    };
};
export const getFormattedPayloadFromVariablesCard = (mutationVariables, isDCHFlow) => {
    const { id } = mutationVariables.paymentCardInfo;
    const alternatePaymentMethodRequest = getAlternatePaymentMethodRequest(id);
    if (alternatePaymentMethodRequest &&
        alternatePaymentMethodRequest.paymentMedium === 'PINLESS_DEBIT_CARD' &&
        isDCHFlow) {
        const dchDebitCardName = makeAPaymentStore.get(dchDebitCardNameAtom)[id] || {
            firstName: '',
            lastName: ''
        };
        return Object.assign(Object.assign({}, alternatePaymentMethodRequest.paymentCardInfo), { 'cipher.firstName': dchDebitCardName.firstName, 'cipher.lastName': dchDebitCardName.lastName });
    }
    if (alternatePaymentMethodRequest) {
        return alternatePaymentMethodRequest.paymentCardInfo;
    }
    return {
        id
    };
};
